<template>
    <div class="container-fluid">
        <div class="row">
            <div class="col-12">
                <div class="card card-form">
                    <div class="card-header">
                        <div class="row">
                            <div class="col">
                                <div class="pull-left">
                                    <h4 class="card-title float-left" v-if="asset.id">
                                        {{$t("asset.title")}}
                                    </h4>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col">
                                <div class="alert alert-warning d-flex" v-if="asset.status === 'Pending'">
                                    <i class="fa-fw fa fa-warning mr-1"></i>
                                    <label style="color: #4d2600; font-size: 14px"><strong>Янги! </strong> Аралаш
                                        мол-мулк маълумотларини кўриб баҳоловчига беринг.</label>
                                </div>
                                <div class="alert alert-danger" v-if="asset.status === 'Rejected'">
                                    <strong>Бекор қилинган!</strong> Баҳолаш жараёни бекор қилинган...
                                </div>
                                <div class="alert alert-success d-flex" v-if="asset.status === 'AssignedToEvaluator'">
                                    <i class="fa-fw fa fa-check mr-1"></i>
                                    <label style="color: #4d2600; font-size: 14px"><strong>Баҳолаш жараёни! </strong>
                                        Аралаш мол-мулкни баҳоловчи баҳолаяпти.</label>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col">
                                <button class="all-btn add-btn"
                                        v-if="asset.status === 'Pending' && !asset.employee.id && hasPermission('E_BAHOLASH_ASSET_BIND_APPRAISER')"
                                        @click="applyAppraisal('AssignedToEvaluator')"
                                >
                                    <i class="fa fa-check"></i>
                                    {{$t("realEstate.action.bindAppraiser")}}
                                </button>
                                <button class="all-btn delete-btn ml-2"
                                        v-if="asset.status === 'Pending' && !asset.employee.id && hasPermission('E_BAHOLASH_ASSET_REJECT')"
                                        @click="showReject"
                                >
                                    <i class="fa fa-reply"></i>
                                    {{$t("realEstate.action.pending")}}
                                </button>
                            </div>
                        </div>
                    </div>
                    <div class="card-body">
                        <div class="row">
                            <div class="col-12 col-md-8">
                                <div class="form-group">
                                    <label>{{$t("realEstate.field.ownerClient")}}</label>
                                    <div class="form-control">
                                        <div v-if="asset && asset.owner">
                                            <strong>{{ asset.owner.fullName }}</strong>
                                            <span> - {{ asset.owner.firmName }} </span>
                                            <span class="badge badge-primary" v-if="asset.owner.type === 'Legal'"> Юридик шахс</span>
                                            <span class="badge badge-primary" v-else> Жисмоний шахс</span>
                                        </div>
                                    </div>
                                </div>
                                <div class="form-group">
                                    <label>{{$t("realEstate.field.evaluationPurpose")}}</label>
                                    <div class="form-control">
                                        <div v-if="asset.evlGoalType === 'Predge'">Гаровга қўйиш</div>
                                        <div v-else-if="asset.evlGoalType === 'Sale'">Сотиш учун</div>
                                        <div v-else-if="asset.evlGoalType === 'Zero'">Нол қийматида сотиб олиш</div>
                                        <div v-else-if="asset.evlGoalType === 'DeterminingValue'">Бозор қийматини
                                            аниқлаш
                                        </div>
                                        <div v-else-if="asset.evlGoalType === 'Investment'">Инвестиция қийматини
                                            аниқлаш
                                        </div>
                                        <div v-else-if="asset.evlGoalType === 'Privatization'">Хусусийлаштириш</div>
                                        <div v-else-if="asset.evlGoalType === 'FormationStatutoryFund'">Устав
                                            жамғармасини шакллантириш
                                        </div>
                                        <div v-else-if="asset.evlGoalType === 'BusinessDeterminingValue'">Бизнес
                                            қийматини аниқлаш
                                        </div>
                                        <div v-else-if="asset.evlGoalType === 'AcceptToBalance'">Балансга кабул килиш
                                        </div>
                                      <div v-else-if="asset.evlGoalType === 'DeterminationValue'">Қийматини аниқлаш
                                        </div>
                                        <div v-else>Етказилган зарар</div>
                                    </div>
                                    <div class="form-group">
                                        <label>{{$t("realEstate.field.propertyType")}}</label>
                                        <div class="form-control">
                                            <div v-if="asset.evlPropertyType === 'Private'">Хусусий мулк</div>
                                            <div v-else-if="asset.evlPropertyType === 'Government'">Давлат мулки</div>
                                            <div v-else-if="asset.evlPropertyType === 'Society'">Жамият мулки</div>
                                            <div v-else>Жамоа мулки</div>
                                        </div>
                                    </div>

                                    <div class="form-group" v-if="!isOrgTypeMib">
                                        <label>{{$t("realEstate.field.contractAmount")}}</label>
                                        <numeric-input class="form-control" v-model="asset.evlContractAmount"
                                                       :controls="false" :precision="2">
                                        </numeric-input>
                                    </div>

                                    <div class="form-group" v-if="!isOrgTypeMib && isOwnerTypeLegal">
                                        <label>Олдиндан тўлов фоизи 0% дан 100% гача!</label>
                                        <numeric-input class="form-control" v-model="asset.prepayment"
                                                       :controls="false" :precision="2">
                                        </numeric-input>
                                    </div>

                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-12">
                                <div class="section-header">
                                    <h4>Аралаш мол-мулкни бахолаш учун тақдим қилинган хужжатлар</h4>
                                </div>
                            </div>
                            <template>
                                <PreviewDropZone
                                        code="documentsDropZone"
                                        label="Мурожат хати ёки Паспорт нусхаси"
                                        :data="asset.documents"
                                        @change="(files) => {asset.documents = files}"
                                />

                                <template v-if="isOwnerTypeLegal && isOrgTypeMib">
                                    <PreviewDropZone
                                            code="actOfSaleDropZone"
                                            label="realEstate.field.docActOfSale"
                                            :data="asset.actOfSale"
                                            @change="(files) => {asset.actOfSale = files}"
                                    />
                                    <PreviewDropZone
                                            code="decisionDropZone"
                                            label="realEstate.field.docDecision"
                                            :data="asset.decision"
                                            @change="(files) => {asset.decision = files}"
                                    />
                                    <PreviewDropZone
                                            code="playlistDropZone"
                                            label="realEstate.field.docPlaylist"
                                            :data="asset.playlist"
                                            @change="(files) => {asset.playlist = files}"
                                    />
                                </template>
                            </template>
                        </div>
                        <div class="row" v-if="asset.id && asset.id > 0">
                            <div class="col-12">
                                <div v-for="(item, index) in asset.assetItemDtos" :key="item.id">
                                    <div class="section-header">{{ index + 1}}. {{item.province.name}}
                                        {{item.region.name}} {{item.name}} маълумотлари
                                    </div>
                                    <div class="col-md-8">
                                        <div class="section-header">Кўчмас мулклар</div>
                                        <div v-for="(realEstate, realEstateIndex) in item.realEstateDtos"
                                             :key="realEstate.id">
                                            <div class="section-header">{{ realEstateIndex + 1}} - кўчмас мулк
                                                маълумотлари
                                            </div>
                                            <div class="col-md-6">
                                                <div class="form-group">
                                                    <label>{{$t("realEstate.name")}}</label>
                                                    <div>№ {{realEstateIndex + 1}}. {{ realEstate.name }}</div>
                                                </div>
                                            </div>
                                            <PreviewDropZone
                                                    code="cadastreDropZone"
                                                    label="realEstate.field.docCadastre"
                                                    :data="realEstate.cadastre"
                                                    @change="(files) => {realEstate.cadastre = files}"
                                            />
                                            <div v-for="(building, buildingIndex) in realEstate.buildings"
                                                 :key="building.id">
                                                <div class="section-header">{{ buildingIndex + 1}} - бино маълумотлари
                                                </div>
                                                <div class="col-md-6">
                                                    <div class="form-group">
                                                        <label>{{$t("building.field.name")}}</label>
                                                        <div>{{ building.name }}</div>
                                                    </div>
                                                </div>
                                                <PreviewDropZoneEAppraisal
                                                        code="buildingPhotoDropZone"
                                                        label="realEstate.field.docBuildingPhotos"
                                                        :data="building.photos"
                                                        @change="(photos) => {building.photos = photos}"
                                                />
                                                <div class="col-md-6">
                                                    <div class="form-group">
                                                        <label>{{$t("building.field.description")}}</label>
                                                        <div class="form-control">{{ building.description }}</div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="section-header">Автотранспортлар</div>
                                        <div v-for="(auto, autoIndex) in item.autoDtos" :key="auto.id">
                                            <div class="section-header">{{ autoIndex + 1}} - автотранспорт
                                                маълумотлари
                                            </div>
                                            <div class="col-md-6">
                                                <div class="form-group">
                                                    <label>{{$t("auto.name")}}</label>
                                                    <div>{{ auto.name }}</div>
                                                </div>
                                            </div>
                                            <PreviewDropZoneEAppraisal
                                                    code="texPassportDropZone"
                                                    label="auto.texPassport"
                                                    :data="auto.texPassportFiles"
                                                    @change="(texPassportFiles) => {auto.texPassportFiles = texPassportFiles}"
                                            />
                                            <PreviewDropZoneEAppraisal
                                                    code="autoPhotoDropZone"
                                                    label="auto.photos"
                                                    :data="auto.autoPhotos"
                                                    @change="(autoPhotos) => {auto.autoPhotos = autoPhotos}"
                                            />
                                            <div class="col-md-6">
                                                <div class="form-group">
                                                    <label>{{$t("building.field.description")}}</label>
                                                    <div class="form-control">{{ auto.aboutAuto }}</div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="section-header">Асосий воситалар</div>
                                        <div v-for="(fitment, fitmentIndex) in item.fitmentDtos" :key="fitment.id">
                                            <div class="section-header">{{ fitmentIndex + 1}} - асосий восита
                                                маълумотлари
                                            </div>
                                            <div class="col-md-6">
                                                <div class="form-group">
                                                    <label>{{$t("fitment.name")}}</label>
                                                    <div>№ {{fitmentIndex + 1}}. {{ fitment.name }}</div>
                                                </div>
                                            </div>
                                            <PreviewDropZoneEAppraisal
                                                    code="texPassportDropZone"
                                                    label="fitment.texPassport"
                                                    :data="fitment.fitmentTexPassports"
                                                    @change="(texPassportFiles) => {fitment.fitmentTexPassports = texPassportFiles}"
                                            />
                                            <PreviewDropZoneEAppraisal
                                                    code="fitmentPhotoDropZone"
                                                    label="fitment.photos"
                                                    :data="fitment.fitmentPictures"
                                                    @change="(fitmentPhotos) => {fitment.fitmentPictures = fitmentPhotos}"
                                            />
                                            <div class="col-md-6">
                                                <div class="form-group">
                                                    <label>{{$t("building.field.description")}}</label>
                                                    <div class="form-control">{{ fitment.aboutFitment }}</div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <template>
            <b-modal v-model="show" title="Аралаш мол-мулкни бекор қилиш">
                <div class="container-fluid">
                    <div class="form-group">
                        <label>Бекор қилиш сабабини киритинг<span class="red">*</span></label>
                        <textarea class="form-control"
                                  v-model="asset.reasonDesc">
                        </textarea>
                    </div>
                </div>
                <div slot="modal-footer">
                    <button
                            type="button"
                            class="all-btn add-btn float-right ml-2"
                            @click="rejectAppraisal('Rejected')"
                    >{{$t("action.save")}}
                    </button>
                    <button
                            type="button"
                            class="all-btn delete-btn float-right"
                            @click="rejectModalHide"
                    >{{$t("action.cancel")}}
                    </button>
                </div>
            </b-modal>
        </template>
    </div>
</template>

<script>

    import PreviewDropZoneEAppraisal from "@/views/real-estate/PreviewDropZoneEAppraisal";
    import PreviewDropZone from '@/views/real-estate/PreviewDropZone'
    import bModal from 'bootstrap-vue/es/components/modal/modal'
    import {required} from 'vuelidate/lib/validators';

    export default {
        name: "EAssetView",
        components: {
            PreviewDropZone,
            PreviewDropZoneEAppraisal,
            'b-modal': bModal
        },
        data() {
            return {
                processing: false,
                showAssignment: false,
                show: false,
                asset: {
                    assetItemDtos: [],
                    employee: {},
                    reasonDesc: '',
                    evlContractAmount: 0,
                    prepayment: 0
                },
                employees: [],
                goalTypesCommon: ['Predge', 'Sale', 'DeterminingValue', 'FormationStatutoryFund', 'Losses']
            }
        },
        validations: {
            asset: {
                employee: {
                    id: {
                        required: required
                    }
                }
            }
        },
        methods: {
            init() {
                const vm = this;
                const id = this.$route.params.id;

                this.$http.get('/asset/' + id).then(function (values) {
                    vm.employee = values.data.employee;
                    if (!vm.employee) {
                        values.data.employee = {};
                    }
                    vm.asset = values.data;
                });
            },
            applyAppraisal(status) {

                if (this.asset.prepayment && !(this.asset.prepayment >= 0 && this.asset.prepayment <= 100)) {
                    this.$swal({
                        title: this.$t('messages.common.warning'),
                        text: this.$t('Олдиндан тўлов фоизи 0% дан 100% гача!'),
                        type: 'warning'
                    });
                    return ;
                }

                this.processing = true;
                if (!this.validateOfAsset()){
                    this.$swal({
                        title: this.$t('messages.common.warning'),
                        text: this.$t('Мол-мулк қаторлари тўлиқ тўлдирилмаган!'),
                        type: 'warning'
                    });
                    this.processing = false;
                    return false;
                }

                this.$http.post('asset/e-appraisal/status/AssignedToEvaluator', {
                    id: this.asset.id,
                    status: status,
                    evlContractAmount: this.asset.evlContractAmount,
                    prepayment: this.asset.prepayment
                }).then(res => {
                    if (res && res.data && res.data.status === 'SUCCESS') {
                        this.showAssignment = false;
                        this.$swal({
                            title: this.$t('messages.common.success'),
                            text: this.$t('asset.statusSuccess'),
                            type: 'success'
                        });
                        this.asset.status = status;
                    } else {
                        this.$swal({
                            title: this.$t('messages.common.warning'),
                            text: this.$t(res.data.message),
                            type: 'warning'
                        });
                        this.showAssignment = false;
                    }
                    this.processing = false;
                }, () => {
                    this.$swal({
                        title: this.$t('messages.common.error'),
                        text: this.$t('asset.statusError'),
                        type: 'error'
                    });
                    this.showAssignment = false;
                    this.processing = false;
                })
            },
            rejectAppraisal(status) {
                if (this.asset.reasonDesc) {
                    this.processing = true;
                    this.$http.post('asset/e-appraisal/status/reject', {
                        id: this.asset.id,
                        status: status,
                        reasonDesc: this.asset.reasonDesc
                    }).then(res => {
                        if (res && res.data && res.data.status === 'SUCCESS') {
                            this.show = false;
                            this.$swal({
                                title: this.$t('messages.common.success'),
                                text: this.$t('asset.statusSuccess'),
                                type: 'success'
                            });
                            this.asset.status = status;
                        } else {
                            this.$swal({
                                title: this.$t('messages.common.warning'),
                                text: this.$t('asset.statusWarning'),
                                type: 'warning'
                            });
                            this.show = false;
                        }
                        this.processing = false;
                    }, () => {
                        this.$swal({
                            title: this.$t('messages.common.error'),
                            text: this.$t('asset.statusError'),
                            type: 'error'
                        });
                        this.show = false;
                        this.processing = false;
                    })
                } else {
                    this.$swal({
                        title: 'Хабар!',
                        text: 'Бекор қилиш сабабини киритинг!',
                        type: 'warning'
                    });
                }
            },
            showReject() {
                this.asset.reasonDesc = '';
                this.show = true;
            },
            rejectModalHide() {
                this.show = false;
            },
            validateOfAsset() {
                for (let i = 0; i < this.asset.assetItemDtos.length; i++) {
                    let exist = false;
                    if (this.asset.assetItemDtos[i].realEstateDtos && this.asset.assetItemDtos[i].realEstateDtos.length > 0) {
                        for (let j = 0; j < this.asset.assetItemDtos[i].realEstateDtos.length; j++) {
                            if (this.asset.assetItemDtos[i].realEstateDtos[j].buildings && this.asset.assetItemDtos[i].realEstateDtos[j].buildings.length > 0) {
                                exist = true;
                            }
                        }
                    }
                    if (this.asset.assetItemDtos[i].autoDtos && this.asset.assetItemDtos[i].autoDtos.length > 0) {
                        exist = true;
                    }
                    if (this.asset.assetItemDtos[i].fitmentDtos && this.asset.assetItemDtos[i].fitmentDtos.length > 0) {
                        exist = true;
                    }
                    if (!exist) {
                        return false;
                    }
                }
                return true;
            }
        },
        created() {
            this.init();
        },
        computed: {
            isOwnerTypeLegal() {
                return !!(this.asset.owner && this.asset.owner.type && this.asset.owner.type === 'Legal');
            },
            isOrgTypeMib() {
                return !!(this.asset.owner && this.asset.owner.organizationType &&
                    (this.asset.owner.organizationType === 'BUREAU_OF_COMPULSORY_EXECUTION' || this.asset.owner.organizationType === 'CUSTOMS_ADMINISTRATION'));
            }
        }
    }
</script>

<style scoped>

</style>